<template>
  <div class="results-map">
    <MglMap
      :accessToken="accessToken"
      :mapStyle="mapStyle"
      :center.sync="center"
      :zoom.sync="zoom"
      :attributionControl="false"
      @load="onMapLoaded"
    >
      <HomeMarker :coordinates="[initialCenter.lng, initialCenter.lat]" />
      <ResultsMarker
        v-for="(item, i) in dataset"
        :key="item.id"
        :dataset="item"
        :ordinal="i + 1"
        @added="onMarkerAdded($event, item.id)"
        @removed="onMarkerRemoved(item.id)"
        @popupOpen="onPopupOpen"
        @click="$emit('hospitalClick', $event)"
      />
      <MglNavigationControl :showCompass="false" position="bottom-right" />
    </MglMap>
  </div>
</template>

<script>
import HomeMarker from '@/components/ResultsMap/home-marker';
import Mapbox from 'mapbox-gl';
import ResultsMarker from '@/components/ResultsMap/results-marker';
import { MglMap, MglNavigationControl } from 'vue-mapbox';

export default {
  components: { HomeMarker, MglMap, MglNavigationControl, ResultsMarker },
  props: {
    initialCenter: {
      type: Object,
      required: true,
    },
    dataset: {
      type: Array,
      default: () => [],
    },
    focusedMarker: {
      type: String,
      default: null,
    },
  },
  data() {
    const { lat, lng } = this.initialCenter;
    return {
      accessToken: process.env.VUE_APP_MAPBOX_TOKEN,
      mapStyle: process.env.VUE_APP_MAPBOX_STYLE,
      center: [lng, lat],
      markers: {},
      zoom: 11,
    };
  },
  watch: {
    focusedMarker(newVal) {
      if (
        newVal &&
        this.markers[newVal] &&
        !this.markers[newVal].getPopup().isOpen()
      ) {
        this.markers[newVal].togglePopup();
      }
    },
  },
  created() {
    this.mapbox = Mapbox;
    this.map = null;
  },
  methods: {
    onMapLoaded(event) {
      const { map } = event;
      this.map = map;
      this.$emit('mapLoaded', map);
    },
    onMarkerAdded(event, id) {
      this.markers = { ...this.markers, [id]: event.marker };
    },
    onMarkerRemoved(id) {
      if (!(id in this.markers)) return;
      const newMarkers = { ...this.markers };
      delete newMarkers[id];
      this.markers = newMarkers;
    },
    onPopupOpen(popup) {
      // Close any open popups.
      Object.values(this.markers).forEach(marker => {
        const markerPopup = marker.getPopup();
        if (popup !== markerPopup && markerPopup.isOpen()) {
          marker.togglePopup();
        }
      });
    },
  },
};
</script>
